"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEnglishLanguage = exports.doesLanguageHaveReadingText = exports.isLanguageRTL = exports.isKnownLanguageRTL = exports.isLearnLanguageRTL = exports.getLanguagePairCodeOrThrow = exports.getLanguagePairCodeFromKnownAndLearnLanguages = exports.getLanguageWithoutLocale = exports.getLearnLanguage = exports.getKnownLanguage = void 0;
const types_1 = require("@fluent-forever/types");
const getKnownLanguage = (languagePairCode) => types_1.getKnownLanguage(languagePairCode);
exports.getKnownLanguage = getKnownLanguage;
const getLearnLanguage = (languagePairCode) => types_1.getLearnLanguage(languagePairCode);
exports.getLearnLanguage = getLearnLanguage;
const getLanguageWithoutLocale = (languageCode) => types_1.getLanguageWithoutLocale(languageCode);
exports.getLanguageWithoutLocale = getLanguageWithoutLocale;
const getLanguagePairCodeFromKnownAndLearnLanguages = (known, learn) => {
    const candidate = types_1.getLanguagePairCodeFromKnownAndLearnLanguages({
        known: known,
        learn: learn,
    });
    return types_1.isLanguagePairCode(candidate) ? candidate : undefined;
};
exports.getLanguagePairCodeFromKnownAndLearnLanguages = getLanguagePairCodeFromKnownAndLearnLanguages;
const getLanguagePairCodeOrThrow = ({ known, learn, }) => {
    if (!types_1.isKnownLanguageCode(known) || !types_1.isLearnLanguageCode(learn)) {
        throw `Specified language codes are invalid: [${known}, ${learn}]`;
    }
    const langPairCode = types_1.getLanguagePairCodeFromKnownAndLearnLanguages({
        known,
        learn,
    });
    if (!types_1.isLanguagePairCode(langPairCode)) {
        throw `Returned invalid language pair code [${langPairCode}] from language codes [${known}, ${learn}]`;
    }
    return langPairCode;
};
exports.getLanguagePairCodeOrThrow = getLanguagePairCodeOrThrow;
const isLearnLanguageRTL = (languagePairCode) => exports.isLanguageRTL(exports.getLearnLanguage(languagePairCode));
exports.isLearnLanguageRTL = isLearnLanguageRTL;
const isKnownLanguageRTL = (languagePairCode) => exports.isLanguageRTL(exports.getKnownLanguage(languagePairCode));
exports.isKnownLanguageRTL = isKnownLanguageRTL;
const isLanguageRTL = (languageCode) => languageCode === "he-IL";
exports.isLanguageRTL = isLanguageRTL;
const doesLanguageHaveReadingText = (learnLanguageCode) => ["ja-JP", "zh-CN"].includes(learnLanguageCode);
exports.doesLanguageHaveReadingText = doesLanguageHaveReadingText;
const isEnglishLanguage = (languagePairCode) => languagePairCode === "en-US_en-US";
exports.isEnglishLanguage = isEnglishLanguage;
//# sourceMappingURL=language_utils.js.map